import React from "react";

import Assessment from "../../../templates/teacher/Assessment";
import Modal from "../../../atoms/Modal";
import { ISimpleStudent } from "../../../pages/teacher/AssessmentListPage";
import {
  IAssessment,
  IAssessmentAnswer,
  IAssessmentTeacher,
} from "../../../state";

import styles from "./ModalAssessmentStudentDetail.module.scss";

type Props = {
  calling: boolean;
  students: { id: number; full_name: string }[];
  currentStudent: { id: number; full_name: string };
  class_id: number;
  assessment: IAssessmentTeacher;
  assessments_past: IAssessment[];
  assessment_answers: IAssessmentAnswer[];
  pdfToken: string | null;
  updateCurrentStudent: (student: ISimpleStudent) => void;
  handleSubmitComment: (feedback_comment: string) => void;
  onDownloadPDF: () => void;
  onClearPDFToken: () => void;
  onClose: () => void;
};

const ModalAssessmentStudentDetail: React.FC<Props> = ({
  calling,
  students,
  currentStudent,
  class_id,
  pdfToken,
  assessment,
  assessments_past,
  assessment_answers,
  updateCurrentStudent,
  handleSubmitComment,
  onDownloadPDF,
  onClearPDFToken,
  onClose,
}) => {
  const handlePrevStudent = () => {
    if (calling) return;
    const index = students.findIndex(st => st.id === currentStudent.id);
    let studentPrev: { id: number; full_name: string } = students[index - 1];
    if (index !== 0) {
      updateCurrentStudent({ ...studentPrev });
    } else {
      studentPrev = students[students.length - 1];
      updateCurrentStudent({ ...studentPrev });
    }
  };

  const handleNextStudent = () => {
    if (calling) return;
    const index = students.findIndex(st => st.id === currentStudent.id);
    let studentNext: { id: number; full_name: string } = students[index + 1];
    if (index !== students.length - 1) {
      updateCurrentStudent({ ...studentNext });
    } else {
      studentNext = students[0];
      updateCurrentStudent({ ...studentNext });
    }
  };

  return (
    <Modal className={styles.modal} onClose={onClose}>
      <Assessment
        pdfToken={pdfToken}
        classID={class_id}
        calling={calling}
        currentStudent={currentStudent}
        students={students}
        assessment={assessment}
        assessmentsPast={assessments_past}
        assessmentAnswers={assessment_answers}
        onClose={onClose}
        onSubmitFeedback={handleSubmitComment}
        onNextStudent={handleNextStudent}
        onPrevStudent={handlePrevStudent}
        onDownloadPDF={onDownloadPDF}
        onClearPDFToken={onClearPDFToken}
      />
    </Modal>
  );
};

export default ModalAssessmentStudentDetail;
